import { render, staticRenderFns } from "./workPoolDetail.vue?vue&type=template&id=7bb21ff9&scoped=true"
import script from "./workPoolDetail.vue?vue&type=script&lang=js"
export * from "./workPoolDetail.vue?vue&type=script&lang=js"
import style0 from "./workPoolDetail.vue?vue&type=style&index=0&id=7bb21ff9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb21ff9",
  null
  
)

export default component.exports